// /school, web half (006 FR-005; routes.md): School setup is the landing.
import { Redirect } from "expo-router";

export default function SchoolIndexWeb() {
  return <Redirect href="/school/setup" />;
}
